import { render } from "./LoadingPlaceholder.vue?vue&type=template&id=79227266"
import script from "./LoadingPlaceholder.vue?vue&type=script&lang=js"
export * from "./LoadingPlaceholder.vue?vue&type=script&lang=js"

import "./LoadingPlaceholder.vue?vue&type=style&index=0&id=79227266&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__